import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { StateService, UrlService } from '@uirouter/core';

import { CimaCore, GlobalNav, Util, XmStore, XmStoreUtil } from 'core/services';
import { Account, StreetAddress, User } from 'store/user/models';
import { CmsCore } from 'store/cms/models';

@Component({
    selector: 'xm-nav-profile',
    styleUrls: ['./profile.scss'],
    templateUrl: './profile.html',
    standalone: false
})
export class XmNavProfileComponent implements OnInit, OnDestroy {
    @Output() public toggleMobileNav: EventEmitter<void> = new EventEmitter<void>();

    public displayName: string;
    public displayNameFirstCharacter: string;
    public pageData: CmsNavMenuItems;
    public isBusinessUser: boolean;
    public account: Account;
    public serviceAddress: StreetAddress;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private globalNav: GlobalNav;
    private cimaCore: CimaCore;

    constructor(globalNav: GlobalNav, route: UrlService, state: StateService, xmStore: XmStore, cimaCore: CimaCore) {
        Object.assign(this, { globalNav, route, state, xmStore, cimaCore });
    }

    public ngOnInit(): void {
        this.isBusinessUser = this.cimaCore.isBusinessUser;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<User>(User, { returnUndefined: true }), (user: User) => {
            if (this.isBusinessUser) {
                this.displayName = user?.displayName || '';
            } else {
                this.displayName = user?.loggedInUserName || '';
            }
            this.account = user?.account;
            this.serviceAddress = user?.account?.serviceAddress;
            this.displayNameFirstCharacter = this.displayName && this.displayName.slice(0, 1);
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (result: CmsCore) => {
            this.pageData = result.nav.myAccount;
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public closeMobileNav(): void {
        this.toggleMobileNav.emit();
    }

    public generateUiParams(paramsString: string): object {
        return Util.getObjectFromQueryString(paramsString);
    }

    public stateActive(item: CmsNavMenuItems): boolean {
        return this.globalNav.stateActive(item);
    }
}
